import axiosClient from "../../common/axios/axiosConfig";

interface GetRoomTokenResponse {
  token: string;
}

export const getRoomByHashedId = async (
  hashedId: string
): Promise<GetRoomTokenResponse> => {
  try {
    const response = await axiosClient.get<GetRoomTokenResponse>(
      `/room/find/${hashedId}`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar o token da sala:", error);
    throw error;
  }
};
